import { SecondaryButtonTemplate, SecondaryButtonTemplateProps } from "./template";

export type SecondaryButtonProps = SecondaryButtonTemplateProps;

export const SecondaryButton = (props: SecondaryButtonProps): JSX.Element => {
  return <SecondaryButtonTemplate {...props} />;
};
